import { usePrefsStore } from '../store/prefsStore'
import '../styles/CoordinatesDisplay.css'

// Permanent lng/lat readout (pro-GIS style). Click toggles between Decimal
// Degrees (DD) and Degrees-Minutes-Seconds (DMS); the choice persists via prefs.
const toDMS = (value, posChar, negChar) => {
  const hemi = value >= 0 ? posChar : negChar
  const abs = Math.abs(value)
  const deg = Math.floor(abs)
  const minFloat = (abs - deg) * 60
  const min = Math.floor(minFloat)
  const sec = ((minFloat - min) * 60).toFixed(1)
  return `${deg}°${String(min).padStart(2, '0')}'${String(sec).padStart(4, '0')}"${hemi}`
}

export default function CoordinatesDisplay({ coords }) {
  const coordFormat = usePrefsStore((s) => s.coordFormat)
  const collapsed = usePrefsStore((s) => s.coordsCollapsed)
  const setPref = usePrefsStore((s) => s.setPref)

  const toggleFormat = () => setPref('coordFormat', coordFormat === 'DD' ? 'DMS' : 'DD')
  const toggleFold = () => setPref('coordsCollapsed', !collapsed)

  if (collapsed) {
    return (
      <button
        type="button"
        className="coordinates-display coordinates-collapsed pr-widget"
        onClick={toggleFold}
        title="Afficher les coordonnées"
      >
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="10" r="3" /><path d="M12 2a8 8 0 00-8 8c0 5.25 8 12 8 12s8-6.75 8-12a8 8 0 00-8-8z" />
        </svg>
      </button>
    )
  }

  let lngText = '—'
  let latText = '—'
  if (coords) {
    if (coordFormat === 'DMS') {
      latText = toDMS(coords.lat, 'N', 'S')
      lngText = toDMS(coords.lng, 'E', 'W')
    } else {
      latText = `${coords.lat.toFixed(4)}°`
      lngText = `${coords.lng.toFixed(4)}°`
    }
  }

  return (
    <div className="coordinates-display pr-widget">
      <button
        type="button"
        className="coord-fold"
        onClick={toggleFold}
        title="Replier"
        aria-label="Replier les coordonnées"
      >
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
          <path d="M9 6l6 6-6 6" />
        </svg>
      </button>
      <button
        type="button"
        className="coord-readout"
        onClick={toggleFormat}
        title={`Format : ${coordFormat} (cliquer pour basculer DD / DMS)`}
      >
        <span className="coord-pair"><span className="coord-label">Lat</span> {latText}</span>
        <span className="coord-pair"><span className="coord-label">Lon</span> {lngText}</span>
        <span className="coord-format">{coordFormat}</span>
      </button>
    </div>
  )
}
